import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { HeadingText } from '@paypalcorp/pp-react';
import ReturnToMerchantLink from '../../components/returnToMerchant';
import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react';
import { MessageFormat } from '@paypalcorp/worldready';
import templateData from '../../utility/getTemplateData';
import { UNENROLLED_CHARITY_DONATION_BLOCKED } from '../../../../constants/constants';

const SenderEligibilityErrorTile = ({ organizationName, returnUrl }) => {
  const worldReady = useContext(WorldReadyContext);
  let messageKey = 'errors.landingerror.error.sendDonationNotAllowed';
  let headingSize = 'sm';

  if (
    templateData.senderEligibilityCode === UNENROLLED_CHARITY_DONATION_BLOCKED
  ) {
    messageKey = 'errors.landingerror.error.unenrolledCharityDonationBlocked';
    headingSize = 'title';
  }

  return (
    <div className="sender-eligibility-error-tile">
      <HeadingText size={headingSize}>
        <Message id={messageKey} />
      </HeadingText>
      {returnUrl && (
        <ReturnToMerchantLink
          returnLabel={new MessageFormat(worldReady, {
            id: 'errors.landingerror.label.returnTo',
          }).format({ orgName: organizationName })}
          organizationName={organizationName}
          returnUrl={returnUrl}
        />
      )}
    </div>
  );
};

SenderEligibilityErrorTile.propTypes = {
  organizationName: PropTypes.string,
  returnUrl: PropTypes.string,
};

export default SenderEligibilityErrorTile;
